<template>
  <PopupWrapper :hide="cancel" title="Internal Store" :ref="(el: any) => popup = el" class="internal-store popup-float" :hide-close-btn="false">
    <loader-content :ref="(el: any) => {loader = el; onShown()}">
    <div class="d-flex flex-column">
      <div class="d-flex justify-content-center mt-3">
        <CoinsBundle v-if="state.item?.type === PurchasableItemContentType.COINS"  :item="state.item" :buy-btn-disabled="true"></CoinsBundle>
        <LootBoxBundle v-if="state.item?.type === PurchasableItemContentType.LOOT_BOX" :item="state.item" :buy-btn-disabled="true"></LootBoxBundle>
      </div>
      <div class="text-center mt-3">Purchase ID: {{state.purchase?.id}}</div>
      <button @click="success" class="btn btn-primary mt-3">Process purchase</button>
      <button @click="fail" class="btn btn-danger mt-3">Fail purchase</button>
      <button @click="cancel" class="btn btn-secondary mt-3">Cancel purchase</button>

    </div>
    </loader-content>
  </PopupWrapper>
</template>
<style>
.internal-store {
}
</style>
<script setup lang="ts">
import PopupWrapper from "@/components/PopupWrapper.vue";
import {reactive} from "@vue/reactivity";
import {ref} from "vue";
import StoreItemDTO from "@/models/StoreItemDTO";
import CoinsBundle from "@/components/store/CoinsBundle.vue";
import {api} from "@/service/APIClient";
import LoaderContent from "@/components/LoaderContent.vue";
import PurchaseCreateRequestDTO from "@/models/request/PurchaseCreateRequestDTO";
import {useStore} from "vuex";
import { AppEvents } from "@/models/enum/AppEvents";
import LootBoxBundle from "@/components/store/LootBoxBundle.vue";
import {PurchasableItemContentType} from "@/models/enum/PurchasableItemContentType";

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore();
const state = reactive({
  purchase: null as any,
  item: null as StoreItemDTO|null
})

const show = (item: StoreItemDTO) => {
  state.item = item
  popup.value?.show()
}

const onShown = () => {
  loader.value?.load(async () => {
    state.purchase = await api.call.purchases.create({
      itemId: state.item!.id,
      provider: "SELF"
    } as PurchaseCreateRequestDTO)
  });
}

const hide = () => {
  popup.value?.hide()
}

const success = () => {
  loader.value?.load(async () => {
    const purchaseId = state.purchase!.id;
    await api.call.purchases.complete(state.purchase!.id)
    hide()
    store.dispatch('emit', {
      event: AppEvents.PURCHASE_COMPLETED, data: {
        purchaseId,
        item: state.item
      }
    })
  });
}

const fail = () => {
  hide()
}

const cancel = () => {
  loader.value?.load(async () => {
    const purchaseId = state.purchase!.id;
    await api.call.purchases.cancel(state.purchase!.id)
    hide()
    store.dispatch('emit', {
      event: AppEvents.PURCHASE_CANCELED, data: {
        purchaseId,
        item: state.item
      }
    })
  });
}

defineExpose({ show, hide })
const popup = ref<InstanceType<typeof PopupWrapper> | null>(null)

</script>